module.exports = __webpack_public_path__ + "img/office-building_1.3ea1689c.png";